export const FinalFwwRoutes = [
    {
        "url": "/final-fww?week",
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.final-fww",
        "views": {
            "body": {
                "component": "finalFwwPageContainer",
            }
        },
        "route_styles": {
            styles: [],
            framework: "bootstrap_v4"
        },
        "params": {
            week: {
                dynamic: true,
            },
            redirect_to: {
                dynamic: true,
            }
        },
        "type": "frontend",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/final-fww/final-fww.downgrade.module");
                }
            },
        ]
    },
];
//# sourceMappingURL=final-fww.routes.js.map